// Tenantra Inc. - In-app Stripe Embedded Checkout (stays on Tenantra; Stripe handles card + province tax).
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export default function EmbeddedCheckoutPanel({ clientSecret, planLabel, onBack }) {
  return (
    <div className="space-y-4 max-w-2xl mx-auto" data-testid="embedded-checkout">
      <button onClick={onBack} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800 transition-colors" data-testid="embedded-back-btn">
        <ArrowLeft className="w-4 h-4" /> Back to billing
      </button>

      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
        <div className="px-5 py-4 border-b border-slate-100 flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-teal-600 flex items-center justify-center shrink-0">
            <ShieldCheck className="w-4.5 h-4.5 text-white" />
          </div>
          <div>
            <h2 className="text-sm font-bold text-slate-900">Complete your {planLabel || ''} subscription</h2>
            <p className="text-xs text-slate-500">Secure payment — tax is calculated automatically for your province.</p>
          </div>
        </div>
        <div className="p-2 sm:p-4">
          {clientSecret && (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </div>
      </div>
    </div>
  );
}
